import { analizzaXmlAdm, type ContatoreImportato, type EsitoAnalisi } from '@praticheenergia/ad1-engine'
import { creaContatore } from './contatori.api'

/** Fase di test (ANAG-22): gira tutta nel browser e non scrive nulla. */
export async function analizzaFile(file: File): Promise<EsitoAnalisi> {
  return analizzaXmlAdm(await file.text())
}

export interface Confronto {
  readonly righe: readonly { contatore: ContatoreImportato; nuovo: boolean }[]
  /** Perche' l'import non si puo' fare, o null. */
  readonly blocco: string | null
}

export function confronta(esito: EsitoAnalisi, codiceDitta: string, matricoleEsistenti: readonly string[]): Confronto {
  const esistenti = new Set(matricoleEsistenti.map((m) => m.toUpperCase()))
  const righe = esito.contatori.map((contatore) => ({
    contatore,
    nuovo: !esistenti.has(contatore.matricola.toUpperCase()),
  }))
  const bloccante = esito.diagnostiche.find((d) => d.gravita === 'bloccante')
  if (bloccante) return { righe, blocco: bloccante.messaggio }
  // Importare i contatori di un altro impianto e' l'errore da non poter fare.
  if (esito.codiceDitta!.toUpperCase() !== codiceDitta.toUpperCase()) {
    return { righe, blocco: `Il file e dell impianto ${esito.codiceDitta}, non di ${codiceDitta}` }
  }
  return { righe, blocco: null }
}

/** Uno alla volta con la stessa API del dialogo dei contatori: stessi
 * controlli, stessa RLS. Un rifiuto non ferma gli altri. */
export async function importaContatori(
  impiantoId: number,
  contatori: readonly ContatoreImportato[],
): Promise<{ importati: number; errori: string[] }> {
  const errori: string[] = []
  for (const c of contatori) {
    try {
      await creaContatore(impiantoId, {
        codice: c.codice,
        matricola: c.matricola,
        // Il tracciato ADM non le riporta: le completa l'utente.
        cifreIntere: 0,
        costanteLettura: c.costanteLettura,
        kwhDiretti: false,
        tipoScambio: c.tipoScambio ?? '',
        idControparte: c.idControparte ?? '',
        tipologiaConsumo: c.tipologiaConsumo ?? '',
      })
    } catch (e) {
      errori.push(`${c.matricola}: ${e instanceof Error ? e.message : 'errore imprevisto'}`)
    }
  }
  return { importati: contatori.length - errori.length, errori }
}
